
// search todolookbook
class LookbookTokenService {
  constructor() {
    this.config = null;
    this.token = null;
    this.init();

    document.addEventListener('DOMContentLoaded', () => {
      this.initLookbookComment();
      this.initSharedLookbook();
      this.setupSaveButtons();
      this.setupComment();
      this.setupDeleteLookbook();
    });
  }

  async initSharedLookbook() {
    const urlParams = new URLSearchParams(window.location.search);
    const shareLookbookId = urlParams.get('shareKey');

    const container = document.getElementById('shared-lookbook');
    if (!container) {
      console.warn("Element with ID 'shared-lookbook' not found in DOM.");
      return;
    }

    if (!shareLookbookId) {
      container.innerHTML = "No public key found!";
      return;
    }

    try {
      const payload = {
        email: this.config.email
      }

      const externalResponse = await fetch(this.config.proxyUrl + `/api/v1/customers/lookbook/share/${shareLookbookId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload),
      });


      if (!externalResponse.ok) {
        throw new Error(`Server error: ${externalResponse.status}`);
      }

      const shareData = await externalResponse.json();

      const ownerIdString = String(shareData.data.ownerId || '');
      const customerIdString = String(this.config.customerId || '');
      console.log('ownerIdString: ' + ownerIdString);
      console.log('customerIdString: ' + customerIdString);

      if (ownerIdString == customerIdString) {
        const shopifyResponse = await fetch(`/?section_id=lookbook-group-my-lookbook`, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        //const container = document.getElementById('shared-lookbook');
        container.innerHTML = await shopifyResponse.text();
      } else {
        const shopifyResponse = await fetch(`/?section_id=lookbook-group-share`, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        //const container = document.getElementById('shared-lookbook');
        container.innerHTML = await shopifyResponse.text();
        //console.log(shareData)
        this.filterSharedLookbook({
          lookbookIds: shareData.data.lookbooks,
          groupId: shareData.data.groupLookbook,
          isEdit: shareData.data.isEdit,
          ownerName: shareData.data.ownerName
        });
      }
    } catch (error) {
      console.error('Error loading shared lookbook:', error);
    }
  }

  filterSharedLookbook(data) {
    const { lookbookIds, groupId, isEdit, ownerName } = data;
    console.log('ownerName: ' + ownerName);
    const allGroups = document.querySelectorAll('.shared-lookbook-group');

    const ownerNameElement = document.getElementById('owner-shared-lookbook');
    ownerNameElement.innerHTML = ownerName;

    allGroups.forEach(group => {
      const groupDataId = group.getAttribute('data-shared-group-id');
      console.log(`Checking group ${groupDataId} against target ${groupId}`);

      if (groupId && groupDataId !== groupId) {
        group.remove();
      } else {
        console.log(`Keeping group ${groupDataId}`);
        group.style.display = 'block';
      }
    });

    //const allItems = document.querySelectorAll('.saved-lookbook__item[data-shared-lookbook-id]');
    const allItems = document.querySelectorAll('.saved-lookbook__item');

    allItems.forEach(item => {
      console.log(`item` + item);
      const itemDataId = item.getAttribute('data-shared-lookbook-id');
      if (!lookbookIds.includes(itemDataId)) {
        item.remove();
      } else {
        item.style.display = 'block';
      }
    });

    //if (!isEdit) {
      const allDeleteButton = document.querySelectorAll('#shared-lookbook .delete-lookbook');
      allDeleteButton.forEach(button => {
        button.remove();
      })
    //}
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.loadConfig());
    } else {
      this.loadConfig();
    }

    // catch event open model to fetch comment or fetch share information
    subscribe('modal-opener', (data) => {
      if (data.data.element.dataset.lookbookType == 'comment') {
        this.getComments(data.data.element);
      }

      if (data.data.element.dataset.lookbookType == 'share') {
        this.handleShareLookbook(data.data.element)
      }
    });
  }

  initLookbookComment() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('lookbook-delete-comment')) {
        event.preventDefault();
        //Add confirmation dialog
        const confirmDelete = confirm('Are you sure you want to delete this comment?');
        if (!confirmDelete) {
          return;
        }
        this.handleDeleteComment(event.target);
      }
    });
  }

  setupDeleteLookbook() {
    document.addEventListener('click', (event) => {
      const deleteBtn = event.target.closest('.delete-lookbook');
      if (deleteBtn) {
        const confirmed = confirm('Are you sure you want to delete this lookbook?');
        if (!confirmed) return;
        this.handleDeleteLookbook(deleteBtn);
      }
    });
    //console.log('init delete lookbook');
  }

  async handleDeleteLookbook(button) {
    const lookbookId = button.dataset.lookbookId;
    const container = button.closest('.saved-lookbook__item');;

    const urlParams = new URLSearchParams(window.location.search);
    const shareLookbookId = urlParams.get('shareKey');

    if (!lookbookId) {
      console.error('Lookbook ID not found');
      return;
    }

    const token = this.getCurrentToken();

    try {
      let endpoint;

      // 2 case if owner delete or shared user with permission
      if (shareLookbookId) {
        endpoint = this.config.proxyUrl + `/api/v1/customers/lookbook/${shareLookbookId}/${lookbookId}`;
      } else {
        endpoint = this.config.proxyUrl + `/api/v1/customers/lookbook/${lookbookId}`;
      }

      const response = await fetch(endpoint, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();
      container.style.opacity = '0';

      setTimeout(() => {
        const groupContainer = container.closest('.saved-lookbook-group');

        container.remove();

        const remainingItem = groupContainer.querySelectorAll('.saved-lookbook__item')

        if (remainingItem.length === 0) {
          groupContainer.remove();
          location.reload();
        }
      }, 300);


    } catch (error) {
      console.log(error);
    }
  }

  async getComments(button) {
    const lookbookId = button.dataset.lookbookId;
    const token = this.getCurrentToken();

    const urlParams = new URLSearchParams(window.location.search);
    const shareLookbookId = urlParams.get('shareKey');

    console.log('assets/lookbook-group.js');
    console.log('lookbookId: ' + lookbookId);

    try {
      const payload = {
        lookbookId: lookbookId,
        shareLookbook: shareLookbookId
      };

      const response = await fetch(this.config.proxyUrl + '/api/v1/comments/all', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();
      console.log('Comments response:', result);

      if (result.success && result.data) {
        this.renderComments(result.data, button);
      }

    } catch (error) {
      console.error('Error fetching comments:', error);
      this.showErrorMessage('Failed to load comments. Please try again.');
    }
  }

  async handleDeleteComment(button) {
    const container = button.closest('.comment-item');
    if (!container) {
      console.error('Comment container not found');
      return;
    }

    const commentId = container.dataset.commentId;
    if (!commentId) {
      console.error('Comment ID not found');
      return;
    }

    const shareKey = this.getShareLookbook();
    const token = this.getCurrentToken();

    try {
      const url = `${this.config.proxyUrl}/api/v1/comments/${encodeURIComponent(commentId)}/${encodeURIComponent(shareKey || '000-000-000')}`;

      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        let errorMessage = `HTTP error ${response.status}`;
        try {
          const errorData = await response.json();
          if (errorData?.error) {
            errorMessage = errorData.error;
          }
        } catch (jsonErr) {
          console.warn('Could not parse error response as JSON', jsonErr);
        }
        throw new Error(errorMessage);
      }

      const result = await response.json();
      console.log('Comment deleted:', result);

      // Animate and remove element
      container.style.opacity = '0';
      setTimeout(() => container.remove(), 300);

    } catch (error) {
      //console.error('Failed to delete comment:', error);
      alert(error);
    }
  }

  renderComments(comments, button) {
    const lookbookId = button.dataset.lookbookId;
    const commentHistoryContainer = document.querySelector('#lookbook-comment-history-' + lookbookId);

    if (!commentHistoryContainer) {
      console.error('Comment history container not found');
      return;
    }

    commentHistoryContainer.innerHTML = '';

    // if (comments.length === 0) {
    //   commentHistoryContainer.innerHTML = '<p class="no-comments">No comments yet. Be the first to comment!</p>';
    //   return;
    // }

    const sortedComments = comments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    const commentsHTML = this.generateCommentsHTML(sortedComments);

    commentHistoryContainer.innerHTML = `
      <div class="comments-header">
        <h4>Comments</h4>
      </div>
      <div class="comments-list">
        ${commentsHTML}
      </div>
    `;
  }

  generateCommentsHTML(comments) {
    return comments.map(comment => {
      const createdDate = new Date(comment.createdAt);
      const formattedDate = this.formatDate(createdDate);

      return `
        <div class="comment-item" data-comment-id="${comment.id}">
          <div class="comment-header">
            <span class="comment-customer"> ${comment.customer.name}</span>
          </div>
          <div class="comment-content">
            <p>${this.escapeHtml(comment.comment)}</p>
          </div>
          <span class="comment-date">${formattedDate}</span>
          <div class="comment-action">
            <button type="button" class="lookbook-delete-comment" >
              <svg viewBox="0 0 16 19" fill="none">
                <path d="M15.2802 2.92545L11.2111 2.18256L10.8808 1.25449C10.8378 1.07751 10.6804 0.955811 10.4991 0.955811H5.77347C5.59222 0.955811 5.43558 1.07751 5.39182 1.25449L5.07007 2.18256L1.00015 2.92545C0.807373 2.95697 0.669922 3.1221 0.669922 3.31482V4.10117C0.669922 4.31735 0.847259 4.49432 1.06311 4.49432H15.2172C15.4338 4.49432 15.6104 4.31735 15.6104 4.10117V3.31482C15.6104 3.1221 15.4729 2.95697 15.2802 2.92545Z" fill="#666E6E"/>
                <path d="M2.63516 18.2787C2.64749 18.4872 2.82022 18.6484 3.02829 18.6484H13.2508C13.4596 18.6484 13.6324 18.4872 13.6439 18.2787L14.3873 5.89862H1.89258L2.63516 18.2787Z" fill="#666E6E"/>
              </svg>
              <span class="visually-hidden">Delete</span>
            </button>
          </div> 
        </div>
      `;
    }).join('');
  }

  formatDate(date) {
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  showErrorMessage(message) {
    console.error(message);
  }

  async handleShareLookbook(button) {

    const groupLookbookId = button.dataset.groupLookbookId;

    if (!groupLookbookId) {
      console.error('No lookbook group ID found');
      return;
    }

    const token = this.getCurrentToken();
    try {
      const payload = {
        groupLookbookId: groupLookbookId
      };

      const response = await fetch(this.config.proxyUrl + `/api/v1/customers/lookbook/share/group-lookbook/${groupLookbookId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      const result = await response.json();

      if (result.data.publicKey) {
        this.displayShareLink(groupLookbookId, result);
      } else {
        console.log('send request');
      }


    } catch (error) {
      console.error('Error saving to lookbook:', error);
    }
  }

  displayShareLink(groupLookbookId, shareData) {
    const modal = document.querySelector(`#Modal-lookbook-share-${groupLookbookId}`);

    if (!modal) {
      console.error('Share modal not found for group:', groupLookbookId);
      return;
    }

    const readLinkInput = modal.querySelector('input[name="readLink"]');

    const fullUrl = `${window.location.origin}/pages/shared-lookbook?shareKey=${shareData.data.publicKey}`;
    if (readLinkInput) {
      readLinkInput.value = fullUrl;
    }

    const writeLinkInput = modal.querySelector('input[name="writeLink"]');

    if (writeLinkInput) {
      writeLinkInput.value = shareData.data.publicKey + '/edit';
    }

    const sharedEmailInput = modal.querySelector('input[name="shareEmails"]');

    if (sharedEmailInput) {
      //sharedEmailInput.value = shareData.data.sharedEmail.join(',');
    }

    let copyButton = modal.querySelector('.copy-link-btn');
    copyButton.onclick = () => this.copyShareLink(fullUrl, copyButton);

    let sendInvitationButton = modal.querySelector('.send-invitation-btn');
    let sharedEmailsInput = modal.querySelector('input[name="shareEmails"]')
    sendInvitationButton.onclick = () => this.updateAccessToShareLookbook(groupLookbookId, sharedEmailsInput);
  }

  async updateAccessToShareLookbook(groupLookbookId, sharedEmailsInput) {
    const token = this.getCurrentToken();

    const sharedEmails = sharedEmailsInput.value;
    // Split and clean emails
    const emailArray = sharedEmails
        .split(',')
        .map(email => email.trim())
        .filter(email => email !== '');
    if (emailArray.length === 0) {
      alert("Please enter at least one email address.");
      return; // ❌ Stop execution
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emailArray.filter(email => !emailPattern.test(email));

    if (invalidEmails.length > 0) {
      alert("Invalid email(s): " + invalidEmails.join(", "));
      return; // ❌ Stop execution if invalid emails are found
    }

    try {
      const payload = {
        groupLookbookId: groupLookbookId,
        sharedEmails: emailArray
      };

      console.log('payload: ' + JSON.stringify(payload));

      const response = await fetch(this.config.proxyUrl + '/api/v1/customers/lookbook/share', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      const result = await response.json();

      //Show success message
      alert("The email(s) have been saved to the list.");
      sharedEmailsInput.value = "";

      this.displayShareLink(groupLookbookId, result);

    } catch (error) {
      console.error('Error saving to lookbook:', error);
    }
  }

  async copyShareLink(shareLink, button) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(shareLink);
      }
    } catch (error) {
      console.error('Failed to copy link:', error);
    }
  }

  getShareLookbook() {
    //return localStorage.getItem('lookbookshare');
    const urlParams = new URLSearchParams(window.location.search);
    const shareLookbookId = urlParams.get('shareKey') || '000-000-000';
    return shareLookbookId;
  }

  loadConfig() {
    const configScript = document.getElementById('lookbook-config');

    if (!configScript) {
      return;
    }

    try {
      this.config = JSON.parse(configScript.textContent || configScript.innerHTML);

      if (!this.config.proxyUrl || !this.config.shopDomain) {
        throw new Error('Missing required configuration fields');
      }

      this.getAuthToken();
    } catch (error) {
      console.error('Error parsing lookbook configuration:', error);
    }
  }

  async getAuthToken() {
    try {
      console.log('Requesting lookbook authentication token...');

      const headers = {
        'Content-Type': 'application/json',
      };

      const payload = {
        shop: this.config.shopDomain,
        timestamp: Math.floor(Date.now() / 1000).toString(),
        customerId: this.config.customerId,
        email: this.config.email
      };

      const response = await fetch(this.config.proxyUrl + '/api/v1/auth/authenticate', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();

      if (data.data.token) {
        this.token = data.data.token;
        localStorage.setItem('lookbook_auth_token', data.data.token);
      }

      return data;
    } catch (error) {
      console.error('Error getting lookbook auth token:', error);
      this.handleTokenError(error);
      return null;
    }
  }

  getCurrentToken() {
    return this.token || localStorage.getItem('lookbook_auth_token');
  }

  async refreshToken() {
    return await this.getAuthToken();
  }

  clearToken() {
    this.token = null;
    sessionStorage.removeItem('lookbook_auth_token');
  }

  setupSaveButtons() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('save-to-lookbook-btn')) {
        event.preventDefault();
        this.handleSaveLookbook(event.target);
      }
    });
  }

  setupComment() {
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('comment-lookbook-btn')) {
        event.preventDefault();
        this.handleAddComment(event.target);
      }
    });
  }

  addCommentToHistory(newComment, button) {
    const lookbookId = button.dataset.lookbookId;
    const commentHistoryContainer = document.querySelector('#lookbook-comment-history-' + lookbookId);

    if (!commentHistoryContainer) {
      console.error('Comment history container not found');
      return;
    }

    let commentsList = commentHistoryContainer.querySelector('.comments-list');
    let commentsHeader = commentHistoryContainer.querySelector('.comments-header');

    if (!commentsList) {
      commentHistoryContainer.innerHTML = `
        <div class="comments-header">
          <h4>Comments</h4>
        </div>
        <div class="comments-list">
        </div>
      `;
      commentsList = commentHistoryContainer.querySelector('.comments-list');
      commentsHeader = commentHistoryContainer.querySelector('.comments-header');
    }

    const newCommentHTML = this.generateCommentsHTML([newComment]);

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = newCommentHTML;
    const commentElement = tempDiv.querySelector('.comment-item');
    commentElement.classList.add('new-comment');

    commentsList.insertAdjacentHTML('afterbegin', tempDiv.innerHTML);
    commentsHeader.querySelector('h4').textContent = `Comments`;

    const newCommentElement = commentsList.querySelector('.new-comment');
    newCommentElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    setTimeout(() => {
      newCommentElement.classList.remove('new-comment');
    }, 2000);
  }

  async handleAddComment(button) {
    const lookbookId = button.dataset.lookbookId;
    const textareaElement = button.parentElement.querySelector('.comment-textarea');
    const comment = textareaElement.value.trim();

    if (!comment) {
      this.showErrorMessage('Please enter a comment before submitting.');
      return;
    }

    const payload = {
      'comment': comment,
      'lookbookId': lookbookId,
      'shareLookbook': this.getShareLookbook()
    };

    const token = this.getCurrentToken();
    if (!token) {
      await this.refreshToken();
      const newToken = this.getCurrentToken();
      if (!newToken) {
        this.showErrorMessage('Authentication failed. Please try again.');
        return;
      }
    }

    button.disabled = true;

    try {
      const response = await fetch(this.config.proxyUrl + '/api/v1/comments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();

      if (result.success && result.data) {
        this.addCommentToHistory(result.data, button);

        textareaElement.value = '';
      }

    } catch (error) {
      console.log(error);
    } finally {
      button.disabled = false;
      button.textContent = 'Add Comment';
    }
  }

  async handleSaveLookbook(button) {
    const lookbookId = button.dataset.lookbookId;

    if (!lookbookId) {
      console.error('No lookbook ID found');
      return;
    }

    const originalText = button.textContent;
    button.textContent = 'Saving...';
    button.disabled = true;

    try {
      let token = this.getCurrentToken();
      if (!token) {
        await this.refreshToken();
        token = this.getCurrentToken();
        if (!token) {
          throw new Error('Authentication failed');
        }
      }

      const payload = {
        value: [lookbookId]
      };

      const response = await fetch(this.config.proxyUrl + '/api/v1/customers/lookbook', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      // Replace the button with a link to the saved lookbooks page
      const link = document.createElement('a');
      link.href = '/pages/my-saved-lookbook';
      link.className = 'button button--primary saved-lookbook-link';
      link.textContent = 'Go to saved lookbooks';
      button.replaceWith(link);
    } catch (error) {
      console.error('Error saving to lookbook:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }
}

const lookbookTokenService = new LookbookTokenService();

window.LookbookTokenService = lookbookTokenService;